import Types from './actionTypes';

const initialState = {
  loading: false,
  generating: false,
  downloading: false,
  data: [],
};

const reducer = function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case Types.FETCH:
      return { ...state, loading: true };
    case Types.FETCHED:
      return { ...state, loading: false, data: payload.data };
    case Types.GENERATE:
      return { ...state, generating: true };
    case Types.GENERATED:
      return { ...state, data: [], generating: false };
    case Types.DOWNLOAD:
      return { ...state, downloading: true };
    case Types.DOWNLOADED:
      return { ...state, downloading: false };
    default:
      return state;
  }
};

export default reducer;
